import { validateAddress } from "@lib/helpers/CoinHelper";
import {
  WalletAddressCreationType,
  WalletAddressProtocol,
  WalletAddressStatus,
  WalletAddressType,
  WalletType,
} from "@lib/types/Billing";
import * as yup from "yup";

export const walletSchema = yup.object().shape({
  name: yup.string().required().min(3),
  type: yup.string().required().oneOf(Object.values(WalletType)),
  // usage: yup.string().required().oneOf(Object.values(WalletUsageType)),
  customerId: yup.string().required().uuid(),
});

export const aiWalletSchema = yup.object().shape({
  name: yup.string().required().min(3),
  type: yup.string().required().oneOf(Object.values(WalletType)),
  customerId: yup.string().nullable().uuid(),
});

export const walletAddressSchema = yup.object().shape({
  walletId: yup.string().required().uuid(),
  customerId: yup.string().nullable().uuid(),
  status: yup.string().required().oneOf(Object.values(WalletAddressStatus)),
  creationType: yup
    .string()
    .required()
    .oneOf(Object.values(WalletAddressCreationType)),
  network: yup.string().required().oneOf(Object.values(WalletAddressType)),
  protocol: yup.string().required().oneOf(Object.values(WalletAddressProtocol)),
  customId: yup.number().required().min(1),
  walletAddressId: yup.string().required().uuid(),
  address: yup.string().test({
    name: "address",
    message: "Invalid wallet address.",
    test: (value, context) => {
      if (!context?.parent?.network) {
        return context.createError({ message: "Please select a network." });
      }
      return validateAddress(context.parent?.network, value.trim());
    },
  }),
});
